import optionsDefs from "./optionsDefs.json";

export const FORM_DEFINITION_OPTIONS_MODEL_URI =
  "https://rpaconnect.io/formDefinition/options";
const formDefinitionOptionsJsonSchema = {
  uri: "https://app.rpaconnect.io/formDefinition/options/schema.json",
  fileMatch: [FORM_DEFINITION_OPTIONS_MODEL_URI],
  schema: {
    $schema: "https://json-schema.org/draft-07/schema",
    $id: "https://app.rpaconnect.io/schemas/formDefinition/options",
    $ref: "#/$defs/options/Options",
    $defs: {
      options: optionsDefs,
    },
  },
};
export default formDefinitionOptionsJsonSchema;
